/* KORBI storefront: intro film, sword-tip star, bulb picker, detail tabs, sticky buy bar.
   Ported from the approved preview. Each part runs only if its markup is on the page.
   Prices and availability come from Shopify's own variants (the JSON in the buy section), never from this file. */
(function () {
  'use strict';
  var $ = function (id) { return document.getElementById(id); };

  // ---- Intro film: if autoplay is blocked, keep it up with "Tap to play" rather than skip it.
  var intro = $('kb-intro'), film = $('kb-film');
  if (intro && film) {
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches, seen = false;
    try { seen = sessionStorage.getItem('korbiIntro') === '1'; } catch (e) {}
    var done = function () { intro.classList.add('done'); try { sessionStorage.setItem('korbiIntro', '1'); } catch (e) {} };
    var start = function () { film.preload = 'auto'; film.currentTime = 0; var p = film.play(); if (p && p.catch) p.catch(function () { intro.classList.add('tap'); }); };
    film.addEventListener('ended', function () { intro.classList.add('ended'); setTimeout(done, 700); });
    film.addEventListener('error', done);
    film.addEventListener('playing', function () { intro.classList.remove('tap'); });
    $('kb-skip').addEventListener('click', function (e) { e.stopPropagation(); done(); });
    intro.addEventListener('click', function () { if (intro.classList.contains('tap')) film.play(); else done(); });
    if ($('kb-watch')) $('kb-watch').addEventListener('click', function () { intro.classList.remove('done'); intro.classList.remove('ended'); start(); });
    if (reduce || seen) intro.classList.add('done'); else start();
  }

  // ---- Star on the sword tip: it sits at pixel 920,272 of the 1800x756 banner and follows the image's cover crop.
  var im = document.querySelector('.kb .hero img'), g = document.querySelector('.kb .glint');
  if (im && g) {
    var place = function () {
      var nw = im.naturalWidth || 1800, nh = im.naturalHeight || 756, cw = im.clientWidth, ch = im.clientHeight;
      if (!cw || !ch) return;
      var k = Math.max(cw / nw, ch / nh);
      g.style.left = (920 * k + (cw - nw * k) * 0.5) + 'px';
      g.style.top = (272 * k + (ch - nh * k) * 0.4) + 'px';
      if (g.firstElementChild) g.firstElementChild.style.setProperty('--s', Math.max(22, 30 * k) + 'px');
    };
    place(); im.addEventListener('load', place); addEventListener('resize', place); setTimeout(place, 600);
  }

  // ---- Bulb picker
  var buy = document.querySelector('[data-kb-buy]'), raw = $('kb-variants');
  if (buy && raw) {
    var V;
    try { V = JSON.parse(raw.textContent); } catch (e) { V = null; }
    if (V) {
      var cur = buy.getAttribute('data-currency') || 'INR';
      var money = function (cents) {
        try { return new Intl.NumberFormat('en-IN', { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(cents / 100); }
        catch (e) { return (cents / 100).toFixed(0); }
      };
      var NAME = { warm: 'All Weather', cool: 'Clear Sky' }, IMG = { warm: buy.getAttribute('data-img-warm'), cool: buy.getAttribute('data-img-cool') };
      var q = 1, qs = $('kb-q'), shot = $('kb-shot'), err = $('kb-err'), add = $('kb-add'), busy = false;
      var pick = function () {
        var h = document.querySelector('input[name=kb-holder]:checked'), c = document.querySelector('input[name=kb-colour]:checked');
        return { h: h ? h.value : '', c: c ? c.value : 'warm' };
      };
      var variant = function (s) { return (V[s.c] || {})[s.h] || null; };
      var paint = function () {
        var s = pick(), v = variant(s);
        // Holder types that are sold out in this colour are greyed out; if the chosen one just became one, move to the first that is free.
        document.querySelectorAll('input[name=kb-holder]').forEach(function (r) { var x = (V[s.c] || {})[r.value]; r.disabled = !x || !x.available; });
        if (v && !v.available) {
          var free = Array.prototype.find.call(document.querySelectorAll('input[name=kb-holder]'), function (r) { return !r.disabled; });
          if (free) { free.checked = true; s = pick(); v = variant(s); }
        }
        $('kb-pr').textContent = v ? money(v.price) : '';
        $('kb-sel').textContent = NAME[s.c] + ' · ' + s.h + ' · a pair, taxes included';
        $('kb-bbn').textContent = NAME[s.c] + ' · ' + s.h;
        $('kb-bbp').textContent = v ? money(v.price) + ' · pair' : '';
        add.disabled = !v || !v.available;
        add.textContent = v && v.available ? 'Add to cart' : 'Sold out';
        $('kb-t0').src = IMG[s.c];
        var lit = document.querySelector('#kb-thumbs [data-k=lit]');
        if (lit && lit.getAttribute('aria-pressed') === 'true' && shot.getAttribute('src') !== IMG[s.c]) { shot.src = IMG[s.c]; shot.alt = 'KORBI ' + NAME[s.c] + ' bulb, lit'; }
      };
      document.querySelectorAll('#kb-thumbs button').forEach(function (b) {
        b.addEventListener('click', function () {
          var s = pick(); shot.src = b.getAttribute('data-src') || IMG[s.c]; shot.alt = b.getAttribute('aria-label');
          document.querySelectorAll('#kb-thumbs button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        });
      });
      document.querySelectorAll('input[name=kb-holder],input[name=kb-colour]').forEach(function (r) { r.addEventListener('change', paint); });
      var pre = new URLSearchParams(location.search).get('c');
      if (pre === 'cool') { var cc = document.querySelector('input[name=kb-colour][value=cool]'); if (cc) cc.checked = true; }
      var hp = new URLSearchParams(location.search).get('holder');
      if (hp) { var hh = Array.prototype.find.call(document.querySelectorAll('input[name=kb-holder]'), function (r) { return r.value.toLowerCase() === hp.toLowerCase(); }); if (hh) hh.checked = true; }
      paint();
      $('kb-minus').addEventListener('click', function () { q = Math.max(1, q - 1); qs.textContent = q; });
      $('kb-plus').addEventListener('click', function () { q = Math.min(10, q + 1); qs.textContent = q; });
      add.addEventListener('click', function () {
        var v = variant(pick());
        if (!v || !v.available || busy) return;
        busy = true; err.hidden = true; add.textContent = 'Adding…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: q }] }) })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (x) {
            if (!x.ok) throw new Error(x.d && (x.d.description || x.d.message) || 'Could not add to the cart.');
            location.href = '/cart';
          })
          .catch(function (e) { busy = false; err.textContent = (e && e.message) || 'Could not add to the cart. Please try again.'; err.hidden = false; paint(); });
      });
      // Detail tabs; arrow keys move between them.
      var tl = document.querySelectorAll('.kb .tablist [role=tab]');
      var sel = function (t) { tl.forEach(function (x) { var on = x === t; x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1; $(x.getAttribute('aria-controls')).hidden = !on; }); };
      tl.forEach(function (t, i) {
        t.addEventListener('click', function () { sel(t); });
        t.addEventListener('keydown', function (e) { var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (d) { var n = tl[(i + d + tl.length) % tl.length]; sel(n); n.focus(); } });
      });
      // Sticky bar only once the buy section has scrolled away.
      var bar = $('kb-buybar');
      if (bar && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (e) {
          var on = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
          bar.classList.toggle('on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        }).observe(buy);
      }
    }
  }
})();
